export default "__VITE_ASSET__AFPRA7qJ__"